import { ReactElement } from 'react';

import { useBoolean } from '@dreryk/react-common';
import { Modal, ModalWidth } from '@dreryk/react-components';

import { boundServiceTranslationKeys } from '../../../translations';

import { HealthcareProviderPatientPortalBoundServiceCreateButton } from './HealthcareProviderPatientPortalBoundServiceCreateButton';
import { HealthcareProviderPatientPortalBoundServiceCreateForm } from './HealthcareProviderPatientPortalBoundServiceCreateForm';
import { HealthcareProviderPatientPortalBoundServiceCreateModalExitButtons } from './HealthcareProviderPatientPortalBoundServiceCreateModalExitButtons';

type HealthcareProviderPatientPortalBoundServiceCreateModalProps = {
   readonly onBoundServiceCreateSuccess: VoidFunction;
   readonly onClose: VoidFunction;
};

type UseHealthcareProviderPatientPortalBoundServiceCreateModalStateReturn = [
   open: VoidFunction,
   close: VoidFunction,
   opened: boolean
];

export const useHealthcareProviderPatientPortalBoundServiceCreateModalState = (): UseHealthcareProviderPatientPortalBoundServiceCreateModalStateReturn => {
   const [{ setTrue, setFalse }, boundServiceModalOpened] = useBoolean();
   return [setTrue, setFalse, boundServiceModalOpened];
};

export const HealthcareProviderPatientPortalBoundServiceCreateModal = (
   props: HealthcareProviderPatientPortalBoundServiceCreateModalProps
): ReactElement => {
   return (
      <Modal
         testId={'HealthcareProviderPatientPortalBoundServiceCreate'}
         title={boundServiceTranslationKeys.addBound}
         width={ModalWidth.NORMAL}
      >
         <HealthcareProviderPatientPortalBoundServiceCreateForm>
            {({ handleSubmit, formState }) => (
               <>
                  <HealthcareProviderPatientPortalBoundServiceCreateButton
                     handleSubmit={handleSubmit}
                     onSuccess={props.onBoundServiceCreateSuccess}
                  />
                  <HealthcareProviderPatientPortalBoundServiceCreateModalExitButtons
                     onClose={props.onClose}
                     shouldConfirmExit={formState.isDirty}
                  />
               </>
            )}
         </HealthcareProviderPatientPortalBoundServiceCreateForm>
      </Modal>
   );
};
